import { type MaybeRef, computed } from 'vue'

import { productListPageAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

export function useProductListPage(id: MaybeRef<string>) {
  const { pending, data } = useHttpFetch(
    productListPageAPI.getProductListPage,
    {
      queryParams: { id },
    },
  )

  const title = computed(() => {
    return data.value?.displayedTitlePlural
  })
  const tagline = computed(() => data.value?.tagline)

  return {
    pending,
    title,
    tagline,
  }
}
